export default __webpack_public_path__ + "static/media/i-icon.9510d41c.svg";